import loadModuleOnElement from "../../utils/loadModuleOnElement";

const loader = () => import("./post");

export default function postParticleLoader(context) {
    loadModuleOnElement(".live-updates-wrapper", loader, context);
    return context;
}
